import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ["card", "text"];
  static values = { text: String, delayMs: { type: Number, default: 0 } };

  connect() {
    this._boundUpdateText = this.updateText.bind(this);
    document.addEventListener("promote:tooltip-update-text", this._boundUpdateText);
  }

  disconnect() {
    clearTimeout(this._showTimeout);
    document.removeEventListener("promote:tooltip-update-text", this._boundUpdateText);
  }

  toggle() {
    if (this.hasCardTarget) {
      this.cardTarget.classList.toggle("hidden");
    }
  }

  show() {
    if (!this.hasCardTarget || !this.cardTarget.classList.contains("hidden") || !this._hasContent()) return;

    clearTimeout(this._showTimeout);
    if (this.delayMsValue > 0) {
      this._showTimeout = setTimeout(() => {
        this.cardTarget.classList.remove("hidden");
      }, this.delayMsValue);
    } else {
      this.cardTarget.classList.remove("hidden");
    }
  }

  hide() {
    clearTimeout(this._showTimeout);
    if (this.hasCardTarget && !this.cardTarget.classList.contains("hidden")) {
      this.cardTarget.classList.add("hidden");
    }
  }

  updateText(event) {
    if (this.hasCardTarget && this.hasTextTarget) {
      this.textTarget.innerText = event.detail.text;
    }
  }

  _hasContent() {
    return this.hasTextTarget && this.textTarget.innerText.trim().length > 0;
  }
}
